import React from 'react';
import './../styles/Menu.scss';
import { checkIn } from '../api';
import SuccessImg from '../images/success.svg';
import ErrorImg from '../images/error.svg';

class CheckIn extends React.Component<any, any> {
  state = {
    image: '',
  };
  constructor(props: any) {
    super(props);
    checkIn(this.props.match.params.reservationId)
      .then(() => {
        this.setState({ image: SuccessImg });
      })
      .catch(() => {
        this.setState({ image: ErrorImg });
      });
  }

  render() {
    return (
      <div className="text-center d-flex justify-content-center img-fluid h-100 w-100 checkin-bg">
        <img src={this.state.image} />
      </div>
    );
  }
}

export default CheckIn;
